import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom';
import Breadcrum from '../Components/Breadcrums/Breadcrum';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';
import RelatedProducts from '../Components/RealatedProducts/RelatedProducts';

const Product = () => {
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  // const {all_product} = useContext(ShopContext);
  const {productId} = useParams();
  const navigate = useNavigate();
  // const formattedProductId = String(productId).replace(/_/g, ' ');
  // const product = all_product.find((e)=> e.name=== formattedProductId);
  const [product, setProduct] = useState(null);
  console.log(productId);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when productId changes
  }, [productId]);
  useEffect(() => {
    const fetchProduct = async () => {
        if (!productId) return; // Ensure id is available

        try {
            const response = await fetch(`${databaseUrl}/product/${productId}`);
            const data = await response.json();

            if (data.success) {
                setProduct(data.product);
            } else {
                console.error('Failed to fetch product:', data.message);
                navigate('/'); // Navigate to home on failure
            }
        } catch (error) {
            console.error('Error fetching product:', error);
        }
    };

    fetchProduct();
  }, [productId, databaseUrl, navigate]);

  //add
  if(!product){
    console.log('Product not found');
    return null;
  }
  //end

  return (
    <div className='pt-16'>
      <Breadcrum product={product}/>
      <ProductDisplay product={product}/>
      <DescriptionBox product={product}/>
      <RelatedProducts product={product}/>
    </div>
  )
}

export default Product